var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFile = function SvgFile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    className: "file_svg__svg-icon",
    viewBox: "0 0 64 64"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M41.333 4h.967l13.033 13.034V18h-14zm-4.666 0h-28v56h46.666V22.667H36.667z",
    clipRule: "evenodd"
  })));
};
export { SvgFile as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgNjQgNjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgY2xhc3M9InN2Zy1pY29uIj48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTQxLjMzMzMgNEg0Mi4yOTk4TDU1LjMzMzMgMTcuMDMzNVYxOEg0MS4zMzMzVjRaTTM2LjY2NjcgNEg4LjY2NjY3VjYwSDU1LjMzMzNWMjIuNjY2N0gzNi42NjY3VjRaIiBmaWxsPSJjdXJyZW50Q29sb3IiLz48L3N2Zz4=";